// Left-side panel shown while crop mode is active (spec Feature 8).
// Scope: rotate slider + reset. Smart Crop is a disabled placeholder (P2).

import React from 'react';
import { X, Sparkles, RotateCw } from 'lucide-react';

const CropPanel = ({ element, onUpdateElement, onCommit, onCancel }) => {
  if (!element) return null;
  const isFrame = element.type === 'frame';
  const rotation = isFrame ? (element.image?.rotation || 0) : (element.cropRotation || 0);

  const setRotation = (deg) => {
    if (isFrame) {
      onUpdateElement(element.id, { image: { ...element.image, rotation: deg } });
    } else {
      onUpdateElement(element.id, { cropRotation: deg });
    }
  };

  const resetCrop = () => {
    if (isFrame) {
      onUpdateElement(element.id, {
        image: { ...element.image, offsetX: 0, offsetY: 0, scale: 1, rotation: 0 },
      });
    } else {
      onUpdateElement(element.id, { cropOffsetX: 0, cropOffsetY: 0, cropScale: 1, cropRotation: 0 });
    }
  };

  return (
    <div className="w-72 h-full bg-white border-r border-gray-200 flex flex-col" data-testid="crop-panel">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
        <h2 className="text-sm font-semibold text-gray-800">Crop</h2>
        <button type="button" onClick={onCancel} className="p-1 rounded hover:bg-gray-100" aria-label="Close crop panel">
          <X className="w-4 h-4 text-gray-500" />
        </button>
      </div>
      <div className="p-4 space-y-5 flex-1 overflow-auto">
        <div>
          <div className="flex items-center justify-between mb-1">
            <label className="text-xs font-medium text-gray-600 flex items-center gap-1.5">
              <RotateCw className="w-3.5 h-3.5" /> Rotate image
            </label>
            <span className="text-xs text-gray-500">{Math.round(rotation)}°</span>
          </div>
          <input
            type="range"
            min={-180}
            max={180}
            step={1}
            value={rotation}
            onChange={(e) => setRotation(Number(e.target.value))}
            className="w-full"
            data-testid="crop-rotate-slider"
          />
        </div>
        <button
          type="button"
          onClick={resetCrop}
          className="w-full h-9 rounded-lg border border-gray-200 text-xs font-medium text-gray-700 hover:bg-gray-50"
          data-testid="crop-reset"
        >
          Reset crop
        </button>
        <button
          type="button"
          disabled
          title="Coming soon"
          className="w-full h-9 rounded-lg border border-dashed border-gray-200 text-xs font-medium text-gray-400 flex items-center justify-center gap-1.5 cursor-not-allowed"
        >
          <Sparkles className="w-3.5 h-3.5" /> Smart Crop (coming soon)
        </button>
      </div>
      <div className="p-4 border-t border-gray-100 flex gap-2">
        <button type="button" onClick={onCommit} className="flex-1 h-9 rounded-lg bg-violet-600 text-white text-xs font-semibold hover:bg-violet-700">
          Done
        </button>
        <button type="button" onClick={onCancel} className="flex-1 h-9 rounded-lg border border-gray-200 text-xs text-gray-700 hover:bg-gray-50">
          Cancel
        </button>
      </div>
    </div>
  );
};

export default CropPanel;
